function e() {
  return !1;
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/stubFalse.js
// module id = 1572
// module chunks = 67